import { render, staticRenderFns } from "./ChannelName.vue?vue&type=template&id=2d881ed8&scoped=true"
import script from "./ChannelName.vue?vue&type=script&lang=js"
export * from "./ChannelName.vue?vue&type=script&lang=js"
import style0 from "./ChannelName.vue?vue&type=style&index=0&id=2d881ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d881ed8",
  null
  
)

export default component.exports